import React, {useEffect, useState} from "react";
import TotalTimeDetail from "./TotalTimeDetail";
import TotalKmDetail from "./TotalKmDetail";
import {TotalMinutesAndDistanceType} from "../types/General";
import {getTotalDistanceAndMinutesFromAddress} from "../Helper";
import {Trip} from "../types/Trip";
import TotalLdmDetail from "./TotalLdmDetail";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({trip, ldm}: { trip: Trip | null, ldm: number }) => {

    const [totalDistancesAndTime, setTotalDistancesAndTime] = useState<TotalMinutesAndDistanceType>({Min: 0, Km: 0});

    useEffect(() => {
        trip && setTotalDistancesAndTime(getTotalDistanceAndMinutesFromAddress(trip));
    }, [trip]);

    if (!trip) {
        return null;
    }

    return (
        <div className="d-flex bg-primary align-items-center py-1 px-4 mb-3 justify-content-between">
            <div className="d-flex justify-content-between">
                <TotalTimeDetail Min={totalDistancesAndTime.Min} isTotal={true}/>
                <div className="ps-4">
                    <TotalKmDetail Km={totalDistancesAndTime.Km}/>
                </div>
            </div>
            <div>
                <TotalLdmDetail ldm={ldm}/>
            </div>
        </div>
    );
}